const sixthSlider = document.getElementById("sixth-slider");
const sixthTrack = sixthSlider.querySelector("ul");

// Duplicar contenido
sixthTrack.innerHTML += sixthTrack.innerHTML + sixthTrack.innerHTML;

setTimeout(() => {
  sixthSlider.scrollLeft = sixthTrack.scrollWidth / 3;
}, 50);

let isDraggingSixth = false;
let startXSixth;
let scrollLeftSixth;
let velocitySixth = 0;
let lastMoveSixth = 0;
let lastTimeSixth = 0;
let sixthFrame;

let isPausedSixth = false;

sixthSlider.addEventListener("mouseenter", () => {
  isPausedSixth = true;
});

sixthSlider.addEventListener("mouseleave", () => {
  isPausedSixth = false;
  isDraggingSixth = false;
  sixthSlider.style.cursor = 'grab';
});

function autoScrollSixth() {
  if (!isPausedSixth && !isDraggingSixth) {
    sixthSlider.scrollLeft += 1;
    const third = sixthTrack.scrollWidth / 3;
    if (sixthSlider.scrollLeft >= third * 2) {
      sixthSlider.scrollLeft = third;
    }
  }
  setTimeout(autoScrollSixth, 30);
}


sixthSlider.addEventListener("mousedown", (e) => {
  isDraggingSixth = true;
  startXSixth = e.pageX - sixthSlider.offsetLeft;
  scrollLeftSixth = sixthSlider.scrollLeft;
  velocitySixth = 0;
  cancelAnimationFrame(sixthFrame);
});

sixthSlider.addEventListener("mouseup", () => {
  isDraggingSixth = false;
  sixthSlider.style.cursor = 'grab';

  const momentum = () => {
    if (Math.abs(velocitySixth) < 0.1) return;
    sixthSlider.scrollLeft -= velocitySixth;
    velocitySixth *= 1;
    sixthFrame = requestAnimationFrame(momentum);
  };
  momentum();
});

sixthSlider.addEventListener("mousemove", (e) => {
  if (!isDraggingSixth) return;
  e.preventDefault();

  const now = Date.now();
  const x = e.pageX - sixthSlider.offsetLeft;
  const dx = x - startXSixth;
  sixthSlider.scrollLeft = scrollLeftSixth - dx;

  velocitySixth = (x - lastMoveSixth) / (now - lastTimeSixth + 1);
  lastMoveSixth = x;
  lastTimeSixth = now;
});

sixthSlider.addEventListener("touchstart", (e) => {
  isDraggingSixth = true;
  startXSixth = e.touches[0].pageX - sixthSlider.offsetLeft;
  scrollLeftSixth = sixthSlider.scrollLeft;
  cancelAnimationFrame(sixthFrame);
}, { passive: true });

sixthSlider.addEventListener("touchmove", (e) => {
  if (!isDraggingSixth) return;
  const x = e.touches[0].pageX - sixthSlider.offsetLeft;
  const dx = x - startXSixth;
  sixthSlider.scrollLeft = scrollLeftSixth - dx;
}, { passive: true });

sixthSlider.addEventListener("touchend", () => {
  isDraggingSixth = false;
});


// Auto-scroll opcional:
function autoScrollSixth() {
  if (!isDraggingSixth) {
    sixthSlider.scrollLeft += 1;
    const third = sixthTrack.scrollWidth / 3;
    if (sixthSlider.scrollLeft >= third * 2) {
      sixthSlider.scrollLeft = third;
    }
  }
  setTimeout(autoScrollSixth, 30);
}
autoScrollSixth();
